import axios from 'axios'
import { useContext, useState } from 'react'
import { useHistory } from 'react-router'
import urlSearchParams from '../../components/urlSearchParams'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { bulkUploadPopup, toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, ROUTES, success } from '../../shared/constants'

export const useStates = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const history = useHistory()
  const [states, setStates] = useState(false)
  const { deleteNewState, getNewStates, addNewState } = useContext(ConfigurationContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)

  const getAllStates = async (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_ALL_STATE_BY_COMPANY(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPaginate(data.paginate)
        getNewStates(data.data)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const addStates = (dto) => {
    setLoading(true)
    axios
      .post(API.ADD_STATE, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('State Added Successfully', success)
        history.push(ROUTES.STATE)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }
  const updateStates = (dto) => {
    setLoading(true)
    axios
      .put(API.EDIT_STATE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('States  Update Successfully', success)
        getAllStates()
        history.push(ROUTES.STATE)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getStates = (dto) => {
    setLoading(true)
    axios
      .get(API.GET_STATE(dto.stateId), header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data.data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setStates(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const deleteStates = (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_STATE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('State Deleted Successfully', success)

        deleteNewState(dto.stateId)
        setSelected([])
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const deleteManyStates = (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_MANY_STATE, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage(`${dto.stateId.length} State Deleted Successfully`, success)
        dto.stateId.map((item) => deleteNewState(item))
        setSelected([])
      })
      .catch((err) => {
        if (err.response) {
          setLoading(false)
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const BulkUpload = async (dto) => {
    setLoading(true)
    axios
      .post(API.BULK_UPLOAD, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        bulkUploadPopup(data, addNewState)
        getAllStates()
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  return {
    addStates,
    getAllStates,
    deleteStates,
    getStates,
    states,
    updateStates,
    deleteManyStates,
    BulkUpload,
    loading,
    paginate,
  }
}
